import { useMutation, MutationOptions, useQuery } from 'react-query'
import { api } from '../../utils/api'
import { UserLoginParam, UserTokenType, UserLoginParamAD } from './auth-types'
import { setUser } from '../user/user-query'
import { setShowModalDownloadHealthCheckupDetail, setShowModalDownloadInsuranceDetail, setToken } from '../../utils/helper'
import { ContentType } from '../../utils/api/tools'

export const AUTH_URL = '/api/auth'
export const LOGIN_URL = `${AUTH_URL}/login`
export const LOGIN_URL_AD = `/api/auth/mobile_msal/login`
export const LOGIN_TYPE = '/api/loginType'

export const useLoginType = () => {
  return useQuery(LOGIN_TYPE, async () => {
    return await api.belive.get<number>(LOGIN_TYPE)
  })
}

export const useLoginAD = (
  option?: MutationOptions<UserTokenType, { message: string }, UserLoginParamAD>,
) => {
  const { onSuccess } = option || {}

  return useMutation(
    async (data: UserLoginParamAD) => {
      const LOGIN_URL_AD_SERVICE = `${LOGIN_URL_AD}?email=${data.username}&token=${data.tokenId}`
      return api.belive.post<UserTokenType>(LOGIN_URL_AD_SERVICE, {
        contentType: ContentType.JSON,
      })
    },
    {
      onSuccess: (data, variables, context) => {
        setToken(data.token.hash)
        setUser(data.user)
        onSuccess && onSuccess(data, variables, context)
      },
      ...option,
    },
  )
}

export const useLogin = (
  option?: MutationOptions<UserTokenType, { message: string }, UserLoginParam>,
) => {
  const { onSuccess } = option || {}

  return useMutation(
    async (data: UserLoginParam) => {
      return api.belive.post<UserTokenType>(LOGIN_URL, { ...data, by_pass: true })
    },
    {
      onSuccess: (data, variables, context) => {
        setToken(data.token.hash)
        setUser(data.user)
        onSuccess && onSuccess(data, variables, context)
        setShowModalDownloadInsuranceDetail('show')
        setShowModalDownloadHealthCheckupDetail('show')
      },
      ...option,
    },
  )
}
